import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../../styles/globals';
import { ITheme } from '../../../styles/theme';
import CircleMinus from '@/assets/icons/minusInCircle.svg?react';

export const Wrapper = styled.div<{ isPast?: boolean }>`
  width: 100%;
  position: relative;
  min-height: 60px;
  display: grid;
  margin-top: 0.5rem;
  grid-template-columns: 2fr 1fr 1fr 3fr 1fr 1fr;
  pointer-events: ${({ isPast }) => (isPast ? 'none' : 'auto')};
  cursor: ${({ isPast }) => (isPast ? 'not-allowed' : 'default')};
  opacity: ${({ isPast }) => (isPast ? 0.5 : 1)};

  ${({ theme }) => `
    gap: ${theme.layout.spacing.mikro};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
  `};
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  &:first-child {
    margin-left: 2rem;
    justify-content: left;
  }
`;

export const Text = styled(BodyRegularS)`
  line-break: anywhere;

  ${({ theme }) => `
  color: ${theme.colors.neutral.primary[80]};
`}
`;

export const ViewButton = styled(BodyBoldS)`
  cursor: pointer;
  ${({ theme }) => `
  color: ${theme.colors.neutral.primary[80]};
`}
`;

export const DeleteReminder = styled(CircleMinus)`
  cursor: pointer;
`;

export const TextAreaInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TextAreaInput = styled.div<{
  theme: ITheme;
  px: string;
  width: string;
  overflowY?: string;
}>`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  resize: none;
  border-radius: 4px;
  padding: 6px;

  a {
    color: rgba(0, 0, 0, 0.88);
  }

  ${({ theme, px, width, overflowY = 'initial' }) => `
      width: ${width};
      height: ${px};
      overflow-y: ${overflowY};
      background: ${theme.colors.neutral.primary[0]} ;
      border:  1px solid ${theme.colors.neutral.primary[30]};
      ::placeholder,
        ::-webkit-input-placeholder {
          color: ${theme.colors.neutral.primary[40]};
        }
  `}
`;

export const FormatOptions = styled.div`
  display: flex;
  gap: 20px;
`;

export const FormatOption = styled.div`
  display: flex;
  gap: 2px;
`;

export const OptionLabel = styled.div`
  display: flex;
  margin-top: 1px;
`;
